export enum AdditionalColors {
  Black = '#000000',
  BlackOpacity8 = '#00000008',
  BlackOpacity10 = '#0000000A',
  BlackOpacity11 = '#0000001A',
  BlackOpacity12 = '#0000001F',
  BlackOpacity14 = '#00000024',
  BlackOpacity15 = '#00000026',
  BlackOpacity20 = '#00000033',
  BlackOpacity28 = '#0000001C',
  BlackOpacity50 = '#00000087',

  LightGray = '#2020208A',
  Gray79 = '#C9C9C9',
  SpanishGray = '#979797',
  Harmonies = '#EBF8FD',
  PaleAqua = '#BED3E4',
  MilkyWay = '#E7F3F9',
  Honeydew = '#F3F2F2',

  InterstellarBlue = '#081250',
  NavyBlue = '#001538',
  UltramarineShadow = '#0A0146',
}
